var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H3M3 17H8M3 17V4.2002C3 3.08009 3 2.51962 3.21799 2.0918C3.40973 1.71547 3.71547 1.40973 4.0918 1.21799C4.51962 1 5.08009 1 6.2002 1H7.8002C8.9203 1 9.47957 1 9.90739 1.21799C10.2837 1.40973 10.5905 1.71547 10.7822 2.0918C11 2.5192 11 3.07899 11 4.19691V7.0002M8 17H19M8 17V11.3682C8 10.8428 8 10.58 8.063 10.335C8.11883 10.1178 8.21073 9.91184 8.33496 9.72518C8.47505 9.51467 8.67113 9.33843 9.06152 8.9877L11.3631 6.91997C12.1178 6.24192 12.4955 5.90264 12.9225 5.77393C13.2989 5.66045 13.7007 5.66045 14.0771 5.77393C14.5045 5.90275 14.8827 6.2422 15.6387 6.92139L17.9387 8.9877C18.3295 9.33881 18.5245 9.51456 18.6647 9.72518C18.7889 9.91184 18.8807 10.1178 18.9365 10.335C18.9995 10.58 19 10.8428 19 11.3682V17M19 17H21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingWhite);
export default __webpack_public_path__ + "static/media/BuildingWhite.6c88e4fa1f9854a01f9ba130c971b224.svg";
export { ForwardRef as ReactComponent };